<template>
  <div
    ref="kt_modal_estados_consultar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_estados_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="card">
            <div class="card-header">
              <div class="card-title d-flex align-items-center">
                <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                  <inline-svg src="media/icons/duotune/maps/map003.svg" />
                </span>
                <h3 class="fw-bold m-0 text-gray-800">Estados</h3>
              </div>
              <div
                class="btn btn-icon btn-sm btn-active-light-primary mt-6"
                data-bs-dismiss="modal"
                @click="this.$emit('exibirModalEstados', false)"
              >
                <span class="svg-icon svg-icon-1 svg-icon lh-0">
                  <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                </span>
              </div>
            </div>
            <div class="card-body p-0">
              <div
                v-if="this.errosValidacaoGeral.length"
                class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
              >
                <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                  <inline-svg src="media/icons/duotune/general/gen044.svg" />
                </span>
                <div class="d-flex flex-stack flex-grow-1">
                  <div class="fw-bold">
                    <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                    <div class="fs-6 text-gray-600">
                      <ul>
                        <li
                          v-for="value in this.errosValidacaoGeral"
                          :key="value"
                        >
                          {{ value }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-header border-0 pt-5">
                <div class="card-title">
                  <div class="d-flex align-items-center position-relative my-1">
                    <span class="svg-icon svg-icon-1 position-absolute ms-6">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                    <input
                      type="text"
                      id="txtPesquisarStUfs"
                      v-model="tableData.search"
                      @input="onSearch($event.target.value)"
                      class="form-control form-control-solid w-250px ps-15"
                      placeholder="Pesquisar Estados"
                    />
                  </div>
                </div>
                <div class="card-toolbar">
                  <div
                    v-if="checkedStUfs.length === 0"
                    class="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                    <button
                      v-if="this.adicionar"
                      @click="adicionarStUf()"
                      class="btn btn-sm btn-primary"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg" /></span
                      >Adicionar
                    </button>
                  </div>
                  <div
                    v-else
                    class="d-flex justify-content-end align-items-center"
                    data-kt-customer-table-toolbar="selected"
                  >
                    <div class="fw-bolder me-5">
                      <span class="me-2">{{ checkedStUfs.length }}</span
                      >Selecionado(s)
                    </div>
                    <button
                      v-if="this.excluir"
                      type="button"
                      class="btn btn-sm btn-danger"
                      @click="deleteSelecionados()"
                    >
                      Excluír Selecionado(s)
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <Datatable
                  ref="table"
                  :table-header="tableHeader"
                  :table-data="tableData"
                  :table-pagination="tablePagination"
                  :page-sizes="pageSizes"
                  :enable-items-per-page-dropdown="true"
                  :hide-on-single-page="false"
                  empty-table-text="Nenhum estado encontrado"
                  @checked-rows="checkedStUfs = $event"
                >
                  <template v-slot:cell-checkbox="{ row: stUf }">
                    <div
                      class="form-check form-check-sm form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="stUf.id"
                        v-model="checkedStUfs"
                      />
                    </div>
                  </template>
                  <template v-slot:cell-uf="{ row: stUf }">
                    {{ stUf.uf }}
                  </template>
                  <template v-slot:cell-aliq="{ row: stUf }">
                    {{ this.$utils.formatarNumero(stUf.aliq) }}
                  </template>
                  <template v-slot:cell-mva="{ row: stUf }">
                    {{ this.$utils.formatarNumero(stUf.mva) }}
                  </template>
                  <template v-slot:cell-reducao="{ row: stUf }">
                    {{ this.$utils.formatarNumero(stUf.reducao) }}
                  </template>
                  <template v-slot:cell-aliqi="{ row: stUf }">
                    {{ this.$utils.formatarNumero(stUf.aliqi) }}
                  </template>
                  <template v-slot:cell-acoes="{ row: stUf }">
                    <div>
                      <button
                        class="btn btn-sm btn-light btn-active-light-primary"
                        data-kt-menu-trigger="click"
                        data-kt-menu-placement="bottom-end"
                        data-kt-menu-flip="top-end"
                      >
                        Ações
                        <span class="svg-icon svg-icon-5 m-0">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr072.svg"
                          />
                        </span>
                      </button>
                      <div
                        v-if="this.editar || this.excluir"
                        class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                        data-kt-menu="true"
                      >
                        <div v-if="this.editar" class="menu-item px-3">
                          <a @click="editarStUf(stUf)" class="menu-link px-3"
                            >Editar</a
                          >
                        </div>
                        <div v-if="this.excluir" class="menu-item px-3">
                          <a
                            @click="removerRegistro(stUf.id)"
                            class="menu-link px-3"
                            >Excluír</a
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                </Datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="exibirEditarEstado"
    id="kt_modal_estado_editar"
    ref="kt_modal_estado_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.stUf.id === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Estado
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Estado
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.modalEditarEstado(false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div class="col-md-4 fv-row mb-4">
              <label class="form-label">UF</label>
              <select class="form-select" v-model="stUf.uf">
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceara</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espirito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Para</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["uf"] }}
              </div>
            </div>
            <div class="col-md-4 fv-row mb-4">
              <label class="form-label">Alíquota</label>
              <CurrencyInput
                class="form-control mb-2"
                placeholder="Alíquota"
                style="text-align: right"
                v-model="this.stUf.aliq"
                :options="options"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["aliq"] }}
              </div>
            </div>
            <div class="col-md-4 fv-row mb-4">
              <label class="form-label">Margem</label>
              <CurrencyInput
                class="form-control mb-2"
                placeholder="Margem"
                style="text-align: right"
                v-model="this.stUf.mva"
                :options="options"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["mva"] }}
              </div>
            </div>
            <div class="col-md-4 fv-row mb-4">
              <label class="form-label">Redução</label>
              <CurrencyInput
                class="form-control mb-2"
                placeholder="Redução"
                style="text-align: right"
                v-model="this.stUf.reducao"
                :options="options"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["reducao"] }}
              </div>
            </div>
            <div class="col-md-4 fv-row mb-4">
              <label class="form-label">Alíq. Int.</label>
              <CurrencyInput
                class="form-control mb-2"
                placeholder="Alíq. Int."
                style="text-align: right"
                v-model="this.stUf.aliqi"
                :options="options"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["aliqi"] }}
              </div>
            </div>
            <div class="row">
              <div
                v-if="this.user.User.Emitente.crt != 1"
                class="col-md-6 fv-row mb-4"
              >
                <label class="required form-label">S.T</label>
                <div class="input-group mb-2">
                  <input
                    id="txtST"
                    type="text"
                    class="form-control"
                    v-model="stUf.st"
                    maxlength="3"
                  />
                  <button
                    type="button"
                    class="input-group-text"
                    @click="this.modalST(true)"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                  </button>
                </div>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["st"] }}
                </div>
              </div>
              <div
                v-if="this.user.User.Emitente.crt === 1"
                class="col-md-6 fv-row mb-4"
              >
                <label class="required form-label">CSOSN</label>
                <div class="input-group mb-2">
                  <input
                    id="txtCSOSN"
                    type="text"
                    class="form-control"
                    v-model="stUf.csosn"
                    maxlength="4"
                  />
                  <button
                    type="button"
                    class="input-group-text"
                    @click="this.modalCSOSN(true)"
                  >
                    <span class="svg-icon svg-icon-2">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                  </button>
                </div>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["csosn"] }}
                </div>
              </div>
              <div class="d-flex align-self-end mb-7 mb-lg-10 col-auto">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="stUf.simples_nac"
                    id="ckSimplesNacional"
                    tabindex="-1"
                  />
                  <label class="form-check-label pt-2" for="ckSimplesNacional">
                    <h6>Simples Nacional</h6>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="this.modalEditarEstado(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            id="btnConfirmarStUf"
            @click="confirmarStUf()"
            v-bind:data-kt-indicator="this.loadingStUf ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loadingStUf">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <STModal
    v-if="exibirST"
    :st="this.stUf.st"
    @exibirModalST="modalST"
    @confirmarST="confirmarST"
  ></STModal>
  <CSOSNModal
    v-if="exibirCSOSN"
    :csosn="this.stUf.csosn"
    @exibirModalCSOSN="modalCSOSN"
    @confirmarCSOSN="confirmarCSOSN"
  ></CSOSNModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import STModal from "../produtos/STModal.vue";
import CSOSNModal from "../produtos/CSOSNModal.vue";
import CurrencyInput from "@/components/text/CurrencyInput";
import { mapState } from "vuex";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
import {
  hideModal,
  hideModalId,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default {
  emits: ["exibirModalEstados"],
  components: {
    Datatable,
    STModal,
    CSOSNModal,
    CurrencyInput,
  },
  props: {
    idEstoqueSt: { type: Number, required: true },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    confirmarCSOSN(csosn) {
      this.stUf.csosn = csosn;
      this.modalCSOSN(false);
    },
    modalCSOSN(exibir) {
      this.exibirCSOSN = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_csosn_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_csosn_consultar");
          },
          /*close*/ () => {
            this.modalCSOSN(false);
          }
        );
      }
    },
    confirmarST(st) {
      this.stUf.st = st;
      this.modalST(false);
    },
    modalST(exibir) {
      this.exibirST = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_st_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_st_consultar");
          },
          /*close*/ () => {
            this.modalST(false);
          }
        );
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData =
        "&$filter=id_estoque_st eq " + this.idEstoqueSt;
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=id_estoque_st eq " +
          this.idEstoqueSt +
          " and ( contains(uf, '" +
          pesquisa +
          "') or contains(st, '" +
          pesquisa +
          "') or contains(csosn, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa + " )";
        } else {
          this.tableData.filterOData = this.tableData.filterOData + " )";
        }
      } else {
        this.tableData.filterOData =
          "&$filter=id_estoque_st eq " + this.idEstoqueSt;
      }
    },
    async deleteSelecionados() {
      await this.$swal.showQuestionAlert(
        "Deseja remover os registros selecionados?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            for (var i = 0; i < this.checkedStUfs.length; i++) {
              await this.excluirStUf(this.checkedStUfs[i]);
            }
            if (this.excluiuCadastro === true) {
              toast.success("Estados excluídos com sucesso!", {
                timeout: 3000,
              });
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async removerRegistro(id) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            await this.excluirStUf(id);
            if (this.excluiuCadastro === true) {
              toast.success("Estado excluído com sucesso!", {
                timeout: 3000,
              });
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async excluirStUf(id) {
      try {
        await this.$store.dispatch("stUf/deleteStUf", id);
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    modalEditarEstado(exibir) {
      this.exibirEditarEstado = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_estado_editar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_estado_editar");
          },
          /*close*/ () => {
            this.modalEditarEstado(false);
          }
        );
      }
    },
    adicionarStUf() {
      this.stUf = {
        id: 0,
        id_estoque_st: 0,
        uf: "SP",
        aliq: 0,
        mva: 0,
        reducao: 0,
        aliqi: 0,
        simples_nac: false,
        st: "000",
        csosn: "0102",
      };
      this.modalEditarEstado(true);
    },
    async editarStUf(stUf) {
      try {
        var ret = await this.$store.dispatch("stUf/getStUf", stUf.id);
        if (ret.Success === true) {
          this.stUf = ret.Data;
          this.modalEditarEstado(true);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async confirmarStUf() {
      this.errosValidacao = [];
      this.loadingStUf = true;
      this.stUf.simples_nac = this.$utils.booleanToString(
        this.stUf.simples_nac
      );
      if (this.stUf.id === 0) {
        this.stUf.id_estoque_st = this.idEstoqueSt;
        try {
          var ret = await this.$store.dispatch("stUf/postStUf", this.stUf);
          if (ret.Success === true) {
            toast.success("Estado cadastrado com sucesso!", {
              timeout: 3000,
            });
            hideModalId("kt_modal_estado_editar");
            this.modalEditarEstado(false);
            this.$refs.table.load();
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch("stUf/putStUf", this.stUf);
          if (retPut.Success === true) {
            toast.success("Estado alterado com sucesso!", {
              timeout: 3000,
            });
            hideModalId("kt_modal_estado_editar");
            this.modalEditarEstado(false);
            this.$refs.table.load();
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      }
      this.loadingStUf = false;
      this.stUf.simples_nac = this.$utils.stringToBoolean(
        this.stUf.simples_nac
      );
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.StUf.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.StUf.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.StUf.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    this.$utils.requestFocus("txtPesquisarStUfs");
  },
  data() {
    return {
      exibirEditarEstado: false,
      exibirST: false,
      exibirCSOSN: false,
      loadingStUf: false,
      stUf: {
        id: 0,
        id_estoque_st: 0,
        uf: "SP",
        aliq: 0,
        mva: 0,
        reducao: 0,
        aliqi: 0,
        simples_nac: false,
        st: "000",
        csosn: "0102",
      },
      adicionar: false,
      editar: false,
      excluir: false,
      checkedStUfs: [],
      errosValidacaoGeral: [],
      errosValidacao: {},
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "UF",
          key: "uf",
          sortable: true,
        },
        {
          name: "Alíquota",
          key: "aliq",
          sortable: true,
        },
        {
          name: "Margem",
          key: "mva",
          sortable: true,
        },
        {
          name: "Redução",
          key: "reducao",
          sortable: true,
        },
        {
          name: "Alíq. Int.",
          key: "aliqi",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "stUf/getStUfOData",
        selectOData: "?$select=id,uf,aliq,mva,reducao,aliqi",
        filterOData: "&$filter=id_estoque_st eq " + this.idEstoqueSt,
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
    };
  },
};
</script>

<style></style>
